import { useEffect, useState } from 'react'
import { isSignedWithEhr } from '@enlyt/base/helpers/auth'
import { useSelector } from 'react-redux'
import { userSelector } from '@enlyt/base/stores/Auth/Selectors'

const useCheckingEnrSigned = ({ isNeedLoading = false } = {}) => {
  const [loading, setLoading] = useState(false)
  const [isEhrSigned, setIsEhrSigned] = useState(false)
  const user = useSelector(userSelector)

  const checkEhrSigned = async () => {
    try {
      const isEhrSigned = await isSignedWithEhr(user?.idToken)
      setIsEhrSigned(isEhrSigned)
    } catch (e) {
      console.log('Checking ehr signed error, ', e)
    }
  }

  const checkWithLoading = async () => {
    try {
      setLoading(true)
      await checkEhrSigned()
    } finally {
      setLoading(false)
    }
  }

  useEffect(
    () => {
      if (isNeedLoading) {
        checkWithLoading()
      } else {
        checkEhrSigned()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  )

  return {
    loading,
    isEhrSigned
  }
}

export default useCheckingEnrSigned
